module.exports = __webpack_public_path__ + "img/pt2.f7d10991.png";